module.exports = __webpack_public_path__ + "static/media/documentation.7582503b.md";